import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {DashboardContent} from 'components/DashboardContent/styles';
import {ORDER_SOURCE} from 'helpers/constants/orders_v2';
import {
  CLEAR_CUSTOMER_INSIGHTS,
  GET_CUSTOMER_INSIGHTS
} from 'store/customerInsights/action';
import TimePeriodSelector from './components/TimePeriodSelector';
import SegmentCards from './components/SegmentCards';
import TopOpportunities from './components/TopOpportunities';
import CustomerLocationsMap from './components/CustomerLocationsMap';
import TopCustomersTable from './components/TopCustomersTable';
import {
  DEFAULT_TIME_PERIOD,
  TIME_PERIODS,
  TOP_CUSTOMERS_LIMIT
} from './constants';
import {
  PageHeader,
  PageTitleWrap,
  PageTitle,
  PageSubtitle,
  TimePeriodWrap,
  TimePeriodLabel,
  Section
} from './styles';

const CustomerInsights = () => {
  const [period, setPeriod] = useState(DEFAULT_TIME_PERIOD);
  const [customRange, setCustomRange] = useState(null);
  const dispatch = useDispatch();
  const activeLocation = useSelector((state) => state.user?.activeLocation);
  const data = useSelector((state) => state.customerInsightsReducer?.data);
  const locationId = activeLocation?._id;
  const storeLocation =
    activeLocation?.Latitude != null && activeLocation?.Longitude != null
      ? {lat: activeLocation.Latitude, lng: activeLocation.Longitude}
      : null;

  useEffect(() => {
    if (!locationId) return;
    if (
      period === TIME_PERIODS.CUSTOM &&
      (!customRange?.[0] || !customRange?.[1])
    ) {
      return;
    }
    const payload = {
      timePeriod: period,
      topCustomersLimit: TOP_CUSTOMERS_LIMIT,
      sources: [ORDER_SOURCE.SAUCE]
    };
    if (period === TIME_PERIODS.CUSTOM) {
      payload.from = customRange[0];
      payload.to = customRange[1];
    }
    dispatch(GET_CUSTOMER_INSIGHTS(payload));
  }, [locationId, period, customRange]);

  useEffect(() => {
    return () => {
      dispatch(CLEAR_CUSTOMER_INSIGHTS());
    };
  }, []);

  const handlePeriodChange = ({timePeriod, from, to}) => {
    setPeriod(timePeriod);
    if (timePeriod === TIME_PERIODS.CUSTOM && from && to) {
      setCustomRange([from, to]);
    } else {
      setCustomRange(null);
    }
  };

  const summary = data?.summary || {};
  const locations = data?.customerLocations || [];
  const topCustomers = data?.topCustomers || [];

  return (
    <DashboardContent className='DashboardContent'>
      <PageHeader className='AlwaysFlex'>
        <PageTitleWrap>
          <PageTitle>Customers Insights</PageTitle>
          <PageSubtitle>
            Explore your direct-channel customers, where they are located, and
            how often they return.
          </PageSubtitle>
        </PageTitleWrap>
        <TimePeriodWrap>
          <TimePeriodLabel>Time Period</TimePeriodLabel>
          <TimePeriodSelector
            value={period}
            customRange={customRange}
            onChange={handlePeriodChange}
          />
        </TimePeriodWrap>
      </PageHeader>

      <Section>
        <SegmentCards segments={summary} />
      </Section>

      <Section>
        <TopOpportunities />
      </Section>

      <CustomerLocationsMap
        locations={locations}
        storeLocation={storeLocation}
      />

      <TopCustomersTable customers={topCustomers} />
    </DashboardContent>
  );
};

export default CustomerInsights;
